import React, {useState } from "react";
import PropTypes from 'prop-types';
import { Button } from "react-bootstrap";
import { Translate } from "../Translator";
import { ConfigurationApiDatasourceInfo } from "../../ExternalApi/ConfigurationApi"
import { IsEmptyString } from "../GeneralFunctions.jsx"


const DatasourceMonday = (props) => {

    const [mRepainter, SetRepainter] = useState(false); 
    const [mBoards, SetBoards] = useState([])  

    async function GetBoards() 
    {
        try 
        {
            const result = await ConfigurationApiDatasourceInfo(props.SecurityToken, props.IntegrationSettings.DatasourceType, "Boards", props.IntegrationSettings.DatasourceSettings)
            if (result.status === 200)
            {
                const Boards = Object.entries(result.data.Info.Boards).map(([id, name]) => ({ id, name }));
                SetBoards(Boards)
            }        
        } 
        catch (ex) 
        {    
            console.log(ex)
        }
    }

    const SetReady = () => 
    {
        props.OnSetReady(!IsEmptyString(props.IntegrationSettings.DatasourceSettings.ApiToken)
            && !IsEmptyString(props.IntegrationSettings.DatasourceSettings.Domain)
            && !IsEmptyString(props.IntegrationSettings.DatasourceSettings.BoardId))
    }

    const UpdateDatasourceSetting = (aNewValue, aIdentifier) =>
    {
        if (aIdentifier === "ApiToken")
        {
            props.IntegrationSettings.DatasourceSettings.ApiToken = aNewValue
        }
        else if (aIdentifier === "Domain")
        {
            props.IntegrationSettings.DatasourceSettings.Domain = aNewValue
        }
        else if (aIdentifier === "BoardId")
        {
            props.IntegrationSettings.DatasourceSettings.BoardId = aNewValue
        }
       
        SetRepainter(!mRepainter)
        SetReady()
    }

    const BrandingId = sessionStorage.getItem("BrandingId")

    return <div className="scriptitembody">
            <div className="wizardfieldname">{Translate("API token").toUpperCase()} <span className="redtext">*</span></div>
            <div className="wizardfieldvalue"><input autoComplete="new-password" type="text" value={props.IntegrationSettings.DatasourceSettings?.ApiToken || ""} onChange={evt => UpdateDatasourceSetting(evt.target.value, "ApiToken")} className="wizardinputfield"/></div>
            <div className="wizardfieldname">{Translate("Domain").toUpperCase()} <span className="redtext">*</span></div>
            <div className="wizardfieldvalue"><input autoComplete="new-password" type="text" value={props.IntegrationSettings.DatasourceSettings?.Domain || ""} onChange={evt => UpdateDatasourceSetting(evt.target.value, "Domain")} className="wizardinputfield"/></div>
            <div className="wizardfieldname">{Translate("Board").toUpperCase()} <span className="redtext">*</span></div>
            <div className="wizardfieldvalue">
                <select name="Application" onChange={evt => UpdateDatasourceSetting(evt.target.value, "BoardId")} className="wizardinputfield">
                    {mBoards.map((board,index) => <option key={index} value={board.id} selected={props.IntegrationSettings.DatasourceSettings?.BoardId === board.id}>{board.name}</option>)}                 
                </select>
                <Button variant="primary" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => GetBoards()}>{Translate("Get available boards")}</Button> 
            </div> 
        </div>
}

DatasourceMonday.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceMonday